import axios, { AxiosInstance } from "axios";
// import delay from "@/shared/delay";
// import { SingletonRefreshClient } from "@/api/abstraction/SingletonRefreshClient";
import { useCallback, useMemo } from "react";
import { delay } from "../Shared/delay";
import { useAuthorization } from "../Contexts/Hooks/useAuth";
import { SingletonRefreshClient } from "./SingletonRefreshClient";
// import { useTrimbleApi } from "./useTrimbleApi";


export function useApi<T>(ApiClass: new (url: string, axios: AxiosInstance) => T) {
  const { token } = useAuthorization();

  const GetApiAddress = useCallback((): string => {
    console.log('REACT_APP_API_URL', process.env.REACT_APP_API_URL);
    return process.env.REACT_APP_API_URL!;
  }, []);
  const Unauthorized = useCallback((): T => {
    const axiosApiInstance = axios.create();

    // Request interceptor for API calls
    axiosApiInstance.interceptors.request.use(
      async config => {
        if (config.headers === undefined) config.headers = {};
        config.headers["Content-Type"] = 'application/json';
        config.headers["Accept"] = 'application/json';
        config.headers["accept-language"] = 'cs';
        config.headers["TimeZone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;

        return config;
      },
      error => {
        Promise.reject(error)
      });

    const apiInstance = new ApiClass(GetApiAddress(), axiosApiInstance);
    if (!apiInstance) {
      throw new Error("Failed to create Unauthorized API instance");
    }
    return apiInstance;
  }, [ApiClass, GetApiAddress]);

  const unauthorizedApi = useMemo(() => {
    let apiInstance = Unauthorized();
    return apiInstance;
  }, [Unauthorized]);
  const Authorized = useCallback((): T | null => {
    const axiosApiInstance = axios.create();

    if ((token === null || token === undefined) && localStorage.getItem('token') === null) return null;
    // Request interceptor for API calls
    axiosApiInstance.interceptors.request.use(
      async config => {
        const localToken = localStorage.getItem('token');
        if (config.headers === undefined) config.headers = {};
        config.headers.Authorization = `Bearer ${localToken ?? token}`;
        config.headers.Accept = 'application/json';
        config.headers['Content-Type'] = 'application/json';
        config.headers['TimeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;

        return config;
      },
      error => {
        Promise.reject(error)
      });
    axiosApiInstance.interceptors.response.use((response) => {
      return response
    }, async function (error) {
      const originalRequest = error.config;
      if (error.response.status === 401 && !originalRequest._retry) {

        try {
          if (error.response.headers['is-token-expired'] === 'true') {
            if (!SingletonRefreshClient.isRefreshing) {
              SingletonRefreshClient.setRefresh();
              originalRequest._retry = true;
              try {
                await SingletonRefreshClient.refreshToken();
              }
              catch (e) {

                console.log(e);
                localStorage.removeItem('token');
                localStorage.removeItem('refresh_token');
                window.location.href = window.location.origin;

              }
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
              SingletonRefreshClient.completeRefresh();
              return axiosApiInstance(originalRequest);
            }
            else delay(1500);


          }
          else window.location.href = window.location.origin;
        }
        catch (e) {
          console.log('error refresh', e);
        }
      }
      return Promise.reject(error);
    });
    const apiInstance = new ApiClass(GetApiAddress(), axiosApiInstance);
    if (!apiInstance) {
      throw new Error("Failed to create Authorized API instance");
    }
    return apiInstance;
  }, [ApiClass, GetApiAddress, token]);
  const authorizedApi = useMemo(() => {
    let apiInstance = Authorized();
    return apiInstance;
  }, [Authorized]);

  return { unauthorizedApi, Unauthorized, authorizedApi, Authorized };
}